import { bindWsEventsToServices } from '@/api/services'
import { io } from 'socket.io-client'
import localStorage from '@/utils/localStorage'
import {
  authStore
} from '@/mixins/authStoreMixin'
import store from '@/store'

const createSocket = (baseURL, params = {}) => {
  let socket

  try {
    socket = io(`${baseURL}/admin`, params)
  } catch (error) {
    console.log('SOCKET ERROR', error)
  }

  return socket
}

const getSocketAuthParams = () => {
  const params = {
    reconnectionAttempts: 20,
    reconnectionDelayMax: 10000,
    transports: ['websocket']
  }

  return params
}

const Socket = {
  install: (Vue, options) => {
    let socket

    const init = () => {
      const params = getSocketAuthParams()
      if (localStorage.getToken()) {
        params.auth = {
          user: {
            ...store.getters[`${authStore.moduleName}/${authStore.getterTypes.GETTER_USER}`],
            token: localStorage.getToken()
          }
        }
      }

      socket = createSocket(options.baseURL, params)
      bindWsEventsToServices(socket)
    }

    const connect = () => {
      socket.auth = {
        user: store.getters[`${authStore.moduleName}/${authStore.getterTypes.GETTER_USER}`],
        token: localStorage.getToken()
      }
      socket.connect()
    }

    Vue.prototype.$socket = {
      init,
      connect
    }
  }
}

export default Socket
